// ==============================================
// OAuth Callback Page
// ==============================================
// Better Auth handles the OAuth exchange server-side.
// This page just redirects to the dashboard after the
// server sets the session cookie.

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';

export function CallbackPage() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading) {
      const from = (location.state as { from?: string })?.from || '/dashboard';
      navigate(isAuthenticated ? from : '/login', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, location]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4">
          <svg className="animate-spin w-16 h-16 text-cyan-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-white mb-2">Completing Sign In</h2>
        <p className="text-slate-400">Please wait while we verify your credentials...</p>
      </div>
    </div>
  );
}

export default CallbackPage;
